import React,{ useRef } from "react";
// import certificate from '../../../assets/images/certificate_bg.png';
import certificate from '../../../assets/images/certificate.jpeg';
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { FiDownload } from "react-icons/fi";
import { baseUrl, ROUTE_BASE_URL } from "../../../api/common";

const MembershipCertificate = ({certificateDetails, firstName, middleName,lastName, applicationName, membershipNumber, membershipDate}) => {

    const certificateRef = useRef(null);

    const handleDownloadPDF = () => {
        if (!certificateRef.current) return;
    
        // Use html2canvas to capture the invoice as an image
        html2canvas(certificateRef.current, {
          scale: 2,
          logging: false,
          useCORS: true,
        }).then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
    
          // Create PDF with proper dimensions (A4)
          const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
          });
    
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();
          const imgWidth = canvas.width;
          const imgHeight = canvas.height;
          const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
          const imgX = (pdfWidth - imgWidth * ratio) / 2;
          const imgY = 0;
    
          pdf.addImage(
            imgData,
            "PNG",
            imgX,
            imgY,
            imgWidth * ratio,
            imgHeight * ratio
          );
          pdf.save(
            `${firstName}-${membershipNumber}.pdf`
          );
        });
      };
  return (
    <>
      <style>
        {`
          .lino_font {
              font-family: 'Linotext', serif;
          }
          .fs_15 {
              font-size: 15px;
          }
          .certificate-container {
              width: 794px;
              height: 1123px;
              margin: auto;
              position: relative;
              text-align: center;
              padding: 9pc 7pc 8pc 6pc;
              background: white;
              background-image: url(${certificate});
              background-size: 100% 100%;
              background-position: center;
              background-repeat: no-repeat;
          }
          .certificate-header img {
              width: 100px;
              margin-bottom: 20px;
          }
          .certificate-title {
              color: red;
          }
          .certificate-content {
              margin: 15px 0;             
              font-size: 16px;
          }
          .mt-40{
            margin-top: 40px;
          }
          .mt-30{
            margin-top: 30px;
          }
          .mb-30{
            margin-bottom: 30px;
          }
          .certificate-name {
              font-weight: bold;
              font-size: 25px;
          }
          .details-section {
              display: flex;
              justify-content: space-between;
          }
          .signature-section {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 40px;
          }
          .signature-box {
              text-align: center;
          }
          .signature-box img {
              width: 120px;
          }
          .seal-logo img {
              width: 120px;
          }
        `}
      </style>
        <div className="w-full relative mb-16 download_button_div">
            <button onClick={handleDownloadPDF} className="btn btn-primary">
                <FiDownload size={18} /> Download PDF
            </button>
        </div>

      <div ref={certificateRef} className="certificate-container">
        {/* Logo */}
        {certificateDetails && certificateDetails.top_logo && (
        <div className="certificate-header">
          <img src={`${baseUrl}/${certificateDetails.top_logo}`} alt="AMASI Logo" />
        </div>)}

        {/* Certificate Header */}
        <h2 className="lino_font certificate-title mt-4">
          Association of Minimal Access Surgeons of India
        </h2>

        {/* Certificate Content */}
        <p className="certificate-content mt-40">
          The President <br /> and <br /> The Executive Committee <br />
          In recognition of the Qualifications and <br />
          Dedication to the Practice of <br />
          Art & Science of Minimal Access Surgery <br />
          hereby Admit
        </p>

        {/* Certificate Name */}
        <h3 className="certificate-name mt-30 mb-30">
          Dr. {firstName ? firstName : ""}
              {middleName ? " " + middleName : ""}
              {lastName ? " " + lastName : ""}
        </h3>
        <p className="certificate-content">
          As an {applicationName} <br />
          Association of Minimal Access Surgeons of India
        </p>

        {/* Membership & Date */}
        <div className="details-section mt-40">
          <p className="fs_15">Membership No: {membershipNumber}</p>
            {new Date(membershipDate) > new Date("2015-12-31") && (
              <p className="fs_15">Date: {membershipDate}</p>
            )}
          {/* <p className="fs_15">Date: {membershipDate}</p> */}
        </div>

        {/* Signatures & Seal */}
        <div className="signature-section">
          {certificateDetails &&certificateDetails.president_sign && certificateDetails.president_name &&
          <div className="signature-box">
            <img src={`${baseUrl}/${certificateDetails.president_sign}`} alt="President Sign" />
            <p>{certificateDetails.president_name}</p>
            <p>President</p>
          </div>
          }
         {certificateDetails && certificateDetails.bottom_logo && (
          <div className="seal-logo">
            <img src={`${baseUrl}/${certificateDetails.bottom_logo}`} alt="AMASI Seal" />
          </div>)}
         {certificateDetails &&certificateDetails.secretary_sign && certificateDetails.secretary_name &&
          <div className="signature-box">
            <img src={`${baseUrl}/${certificateDetails.secretary_sign}`} alt="Secretary Sign" />
            <p>{certificateDetails.secretary_name}</p>
            <p>Secretary</p>
          </div>
          }
        </div>
      </div>
    </>
  );
};

export default MembershipCertificate;
